// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IHealthPlanEnrollmentBreakdownRecordDto
 */
export interface IHealthPlanEnrollmentBreakdownRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    member_type?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    health_plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    plan_code?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    coverage_code?: string;
    /**
     * 
     * @type {Date}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    enrollment_effective_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    hra_status?: string;
    /**
     * 
     * @type {Date}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    hra_enrollment_effective_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    hra_available_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    hra_enroll_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    tier?: string;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    current_family_deductible_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    current_embedded_deductible_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    partner_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    partner_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    distributor_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    employer_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    subsidiary_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    employer_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    id_source?: string;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    employee_id?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof IHealthPlanEnrollmentBreakdownRecordDto
     */
    custom_field_name_to_value?: { [key: string]: string; };
}

/**
 * Check if a given object implements the IHealthPlanEnrollmentBreakdownRecordDto interface.
 */
export function instanceOfIHealthPlanEnrollmentBreakdownRecordDto(value: object): value is IHealthPlanEnrollmentBreakdownRecordDto {
    return true;
}

export function IHealthPlanEnrollmentBreakdownRecordDtoFromJSON(json: any): IHealthPlanEnrollmentBreakdownRecordDto {
    return IHealthPlanEnrollmentBreakdownRecordDtoFromJSONTyped(json, false);
}

export function IHealthPlanEnrollmentBreakdownRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHealthPlanEnrollmentBreakdownRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'member_type': json['member_type'] == null ? undefined : json['member_type'],
        'health_plan_name': json['health_plan_name'] == null ? undefined : json['health_plan_name'],
        'plan_code': json['plan_code'] == null ? undefined : json['plan_code'],
        'coverage_code': json['coverage_code'] == null ? undefined : json['coverage_code'],
        'enrollment_effective_date': json['enrollment_effective_date'] == null ? undefined : (new Date(json['enrollment_effective_date'])),
        'hra_status': json['hra_status'] == null ? undefined : json['hra_status'],
        'hra_enrollment_effective_date': json['hra_enrollment_effective_date'] == null ? undefined : (new Date(json['hra_enrollment_effective_date'])),
        'hra_available_balance': json['hra_available_balance'] == null ? undefined : json['hra_available_balance'],
        'hra_enroll_amount': json['hra_enroll_amount'] == null ? undefined : json['hra_enroll_amount'],
        'tier': json['tier'] == null ? undefined : json['tier'],
        'current_family_deductible_amount': json['current_family_deductible_amount'] == null ? undefined : json['current_family_deductible_amount'],
        'current_embedded_deductible_amount': json['current_embedded_deductible_amount'] == null ? undefined : json['current_embedded_deductible_amount'],
        'partner_external_identifier': json['partner_external_identifier'] == null ? undefined : json['partner_external_identifier'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'distributor_external_identifier': json['distributor_external_identifier'] == null ? undefined : json['distributor_external_identifier'],
        'employer_external_identifier': json['employer_external_identifier'] == null ? undefined : json['employer_external_identifier'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'subsidiary_external_identifier': json['subsidiary_external_identifier'] == null ? undefined : json['subsidiary_external_identifier'],
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'id_source': json['id_source'] == null ? undefined : json['id_source'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'custom_field_name_to_value': json['custom_field_name_to_value'] == null ? undefined : json['custom_field_name_to_value'],
    };
}

export function IHealthPlanEnrollmentBreakdownRecordDtoToJSON(json: any): IHealthPlanEnrollmentBreakdownRecordDto {
    return IHealthPlanEnrollmentBreakdownRecordDtoToJSONTyped(json, false);
}

export function IHealthPlanEnrollmentBreakdownRecordDtoToJSONTyped(value?: IHealthPlanEnrollmentBreakdownRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'member_type': value['member_type'],
        'health_plan_name': value['health_plan_name'],
        'plan_code': value['plan_code'],
        'coverage_code': value['coverage_code'],
        'enrollment_effective_date': value['enrollment_effective_date'] == null ? undefined : ((value['enrollment_effective_date']).toISOString().substring(0,10)),
        'hra_status': value['hra_status'],
        'hra_enrollment_effective_date': value['hra_enrollment_effective_date'] == null ? undefined : ((value['hra_enrollment_effective_date']).toISOString().substring(0,10)),
        'hra_available_balance': value['hra_available_balance'],
        'hra_enroll_amount': value['hra_enroll_amount'],
        'tier': value['tier'],
        'current_family_deductible_amount': value['current_family_deductible_amount'],
        'current_embedded_deductible_amount': value['current_embedded_deductible_amount'],
        'partner_external_identifier': value['partner_external_identifier'],
        'partner_name': value['partner_name'],
        'distributor_external_identifier': value['distributor_external_identifier'],
        'employer_external_identifier': value['employer_external_identifier'],
        'employer_name': value['employer_name'],
        'subsidiary_external_identifier': value['subsidiary_external_identifier'],
        'subsidiary_name': value['subsidiary_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'partner_employee_id': value['partner_employee_id'],
        'employer_employee_id': value['employer_employee_id'],
        'ssn': value['ssn'],
        'id_source': value['id_source'],
        'employee_id': value['employee_id'],
        'custom_field_name_to_value': value['custom_field_name_to_value'],
    };
}

